import { createAction, props } from '@ngrx/store';

export const loadBrand = createAction('[Common] Load Brand');
export const loadBrandSuccess = createAction(
  '[Common] Load Brand Success',
  props<{ brand: string }>()
);

export const goToStripeDashboard = createAction(
  '[Common] Go To Stripe Dashboard'
);
export const goToStripeDashboardSuccess = createAction(
  '[Common] Go To Stripe Dashboard Success',
  props<{ url: string }>()
);
export const goToStripeDashboardFailure = createAction(
  '[Common] Go To Stripe Dashboard Failure',
  props<{ error: Error }>()
);
